import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { RequestOtpViaMsisdnDTO } from '@core/models/dto.models';
import { RequestOtpApiResponse } from '@core/models/api.response';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OtpService {
  constructor(private http: HttpClient) {}

  async requestOtp(data: RequestOtpViaMsisdnDTO): Promise<RequestOtpApiResponse> {
    return firstValueFrom(
      this.http.post<RequestOtpApiResponse>(`${environment.apiUri}/profile/request-otp`, {
        msisdn: data.msisdn,
        recaptchaToken: data.recaptchaToken,
      })
    );
  }
}
